import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { GeolocationOutput } from 'libs/end-to-end/src/custom-viz/GeolocationTypes';

export const GeolocationCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'geolocation',
  isDataQueuingAllowed: true,
  outputFileName: 'geolocation_output.json',
  outputSchema: GeolocationOutput,
  resolveFocusArea: () => null,
  resolveFilters: (request) => {
    if (request.customVizId !== 'geolocation') {
      throw new Error('Invalid customVizId');
    }
    return request.inputs.extras.filters;
  },
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => {
    if (request.customVizId !== 'geolocation') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      'Selected Dimensions': [],
      Filters: request.inputs.extras.filters,
      'Selected Metrics': request.inputs.extras.metrics ?? [],
      'Selected Focus Areas': [],
    };
  },
  getUrlPath: () => 'explore/geolocation',
};
